import clsx from "classnames";
import React from "react";

import styles from "./index.module.css";

interface LabelProps extends React.ComponentProps<"label"> {
  /** Label text content */
  children: React.ReactNode;
  /** Whether the field is required */
  isRequired?: boolean;
  /** Whether the field has an error */
  hasError?: boolean;
  /** Whether the field is disabled */
  isDisabled?: boolean;
  /** To link a label to its input */
  htmlFor?: string;
}

/**
 * A label component for form fields that provides proper accessibility
 * and consistent styling across the design system.
 */
const Label: React.FC<LabelProps> = ({
  children,
  isRequired = false,
  hasError = false,
  isDisabled = false,
  className,
  ...rest
}) => {
  const classes = clsx(
    styles.root,
    {
      [styles.hasError]: hasError,
      [styles.isDisabled]: isDisabled,
    },
    className
  );

  return (
    <label className={classes} {...rest}>
      {children}
      {isRequired && (
        <span className={styles.requiredIndicator} aria-label="required">
          *
        </span>
      )}
    </label>
  );
};

export default Label;
